function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { Field } from "redux-form";
import { fieldRequired } from "../FormComponents/utils"; //simple enhancer that wraps a component in a redux <Field/> component
//all options are passed as props to <Field/>

export default function WithField(fieldProps) {
  return function AddFieldHOC(Component) {
    return function AddField(_ref) {
      var isRequired = _ref.isRequired,
          rest = _objectWithoutPropertiesLoose(_ref, ["isRequired"]);

      return /*#__PURE__*/React.createElement(Field, _extends({}, isRequired && {
        validate: fieldRequired
      }, fieldProps, rest, {
        component: Component
      }));
    };
  };
}